import { Component, h, Host } from '@stencil/core';

@Component({
    tag: 'sew-ws-product-links-item',
    styleUrl: 'sew-ws-product-links-item.scss',
    shadow: true,
})
export class SewWsProductLinksItem {
    render() {
        return (
            <Host>
                <sew-ws-link size="xl">
                    <slot name="link" />
                </sew-ws-link>
                <slot name="text"></slot>
            </Host>
        );
    }
}
